export const SET_COUNTRY_CODE = 'setCountryCode';

export const setCountryCode = (code) => {
     return {
          type: SET_COUNTRY_CODE,
          payload: code,
     };
};
